import React, { useState, useRef, useEffect } from 'react';
import '../css/searchBar.css';

const FilterInput = ({ item = {}, isOpen, onToggle, value = '', onChange }) => {
  const ref = useRef(null);

  const [texts, setTexts] = useState([]);
  const safeFieldValues = Array.isArray(item.fieldValues)
    ? item.fieldValues
    : [];
  const [fieldValues, setFieldValues] = useState(safeFieldValues);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        if (isOpen === item.id) {
          onToggle(null);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, item.id, onToggle]);

  useEffect(() => {
    if (ref.current) {
      const scrollArea = ref.current.querySelector('.text-search');
      if (scrollArea) {
        scrollArea.scrollLeft = scrollArea.scrollWidth;
      }
    }
  }, []);

  useEffect(() => {
    if (value === '') {
      setTexts([]);
    }
  }, [value]);

  const handleChange = (field) => {
    if (item.isOneSelect) {
      setTexts([{ id: field.id, title: field.value }]);
      if (item.keyword === 'gender') {
        onChange(item.keyword, field.id, false);
      } else onChange(item.keyword, field.value, false);
    } else {
      const alreadyExists = texts.some((t) => t.id === field.id);
      if (!alreadyExists) {
        setTexts([...texts, { id: field.id, title: field.value }]);
        if (item.fieldValues.length > 0) {
          onChange(item.keyword, field.id, true);
        }
      }
    }
  };

  const handleRemove = (text) => {
    setTexts((prev) => prev.filter((t) => t.title !== text.title));

    if (item.keyword === 'work_address') {
      onChange(item.keyword, text.title, 'REMOVE');
    } else {
      onChange(item.keyword, text.id, 'REMOVE');
    }
  };

  const removeVietnameseTones = (str) => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D');
  };

  const handleSearchKey = (e) => {
    const keyword = removeVietnameseTones(e.target.value.toLowerCase());
    onChange(item.keyword, e.target.value);

    setFieldValues(() => {
      if (!keyword) return item.fieldValues;

      const filterData = item.fieldValues.filter((option) => {
        const original = removeVietnameseTones(option.value.toLowerCase());
        return original.includes(keyword);
      });

      return filterData;
    });
  };

  return (
    <div
      className="form-group cell"
      ref={ref}
      onClick={
        Array.isArray(item.fieldValues) && item.fieldValues.length > 0
          ? () => onToggle(item.id)
          : null
      }
    >
      <img src={`/images/icon_search/${item.image}`} alt="" className="icon" />

      {item.isOneSelect ? (
        <div style={{ padding: '0 0.5rem' }}>
          {texts.length > 0 ? (
            <span className="selected">
              <i
                className="fas fa-times"
                onClick={() => handleRemove(texts[0], item.id)}
              ></i>
              {texts[0].title}
            </span>
          ) : (
            <input
              type="text"
              value={value}
              placeholder={item.placeholder}
              onChange={handleSearchKey}
            />
          )}
        </div>
      ) : (
        <ul className="text-search m-0">
          {texts.length > 0 &&
            texts.map((text) => (
              <li key={text.title} className="m-0">
                <span className="selected">
                  <i
                    className="fas fa-times"
                    onClick={() => handleRemove(text, item.id)}
                  ></i>
                  {text.title}
                </span>
              </li>
            ))}
          <li>
            <input
              type="text"
              placeholder={item.placeholder}
              onFocus={
                Array.isArray(item.fieldValues) && item.fieldValues.length > 0
                  ? () => onToggle(item.id)
                  : null
              }
              onChange={handleSearchKey}
            />
          </li>
        </ul>
      )}

      {Array.isArray(item.fieldValues) && item.fieldValues.length > 0 && (
        <img
          className={`ms-auto icon-arrow m-0 ${
            isOpen === item.id ? 'rotate-180' : ''
          }`}
          alt=""
          src="/images/icons/down-arrow.png"
          style={{ margin: '0' }}
        />
      )}

      {Array.isArray(fieldValues) && fieldValues.length > 0 && (
        <div className={`down-option ${isOpen === item.id ? 'show' : ''}`}>
          <ul className="p-0 m-0">
            {fieldValues.length > 0 ? (
              fieldValues.map((field) => (
                <li key={field.id} onClick={() => handleChange(field)}>
                  {field.value}
                </li>
              ))
            ) : (
              <li style={{ textAlign: 'center', color: 'var(--bs-gray-600)' }}>
                Không tìm thấy
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default FilterInput;
